import React from 'react';
import { useTranslation } from 'react-i18next';
import { isValidPublicKey } from '../../utils/account.tsx';
import { CaptionText, FlexColumn } from '@make-software/cspr-ui';
import { BodyText, Tooltip } from '@block-explorer/ui';

const TooltipWithExtendedInfo = ({
  extendedLine,
  publicKey,
  tooltipCaption,
  children,
}: React.PropsWithChildren<{
  publicKey: string;
  tooltipCaption?: string;
  extendedLine?: {
    title: string | undefined;
    caption: string;
  };
}>) => {
  const { t } = useTranslation();

  const hasExtendedLine = extendedLine?.title != undefined;

  const keyTooltipCaption = tooltipCaption
    ? tooltipCaption
    : isValidPublicKey(publicKey)
      ? t('Public Key')
      : t('Account hash');

  const title = hasExtendedLine ? extendedLine?.title : publicKey;
  const caption = hasExtendedLine ? extendedLine?.caption : keyTooltipCaption;

  const additionalBlock = hasExtendedLine && (
    <FlexColumn>
      <CaptionText size={1} variation={'gray'}>
        {keyTooltipCaption}
      </CaptionText>
      <BodyText size={3} monotype>
        {publicKey}
      </BodyText>
    </FlexColumn>
  );

  return (
    <Tooltip
      monotype={!hasExtendedLine}
      title={title}
      caption={caption}
      additionalBlock={additionalBlock}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipWithExtendedInfo;
